import request from '@/utils/request'
import { OVERSEAS_API, COMMON_API } from '@/const/index'
import { BASE_API } from '@/const'
export interface ApiUser {
  userId: string
  enterpriseId: string
  enterpriseName: string
  phone: string
  email: string
  enterpriseUser: boolean
  nickname: string
  auditStatus?: any
  enabled: boolean
  source: string
  accessToken: string
  superAdmin: boolean
  account: string
  authorities?: any
  accountNonExpired: boolean
  accountNonLocked: boolean
  credentialsNonExpired: boolean
  password: string
  username: string
  unit: string
}

export interface MpciParty {
  mpciPartyId: string
  hgj: boolean
  mpciPartyIdNative?: boolean
  mpciPartyIdShipowner?: boolean
}

export interface GlobalSeaCoin {
  currency: string
  value: number
}
export interface UserInfo {
  defaultGlobalSeaCoin: GlobalSeaCoin
  enabledCurrencies: string[]
  globalSeaCoins: GlobalSeaCoin[]
  globalSeaCoin: number
  seaCoin: number
  couponCount: number
  openStatus: string
  currency: string
  user: ApiUser
  changeHouseScac: boolean
  extData: {
    mpciParties: MpciParty[]
  }
}

/**
 * @description: 获取用户信息
 * @return {Promise<DataResponse<UserInfo>>}
 */
export const fetchUserInfo = async (): Promise<UserInfo> => {
  const res = await request<UserInfo>('/user/me', {
    method: 'get',
    baseURL: COMMON_API,
  })
  return res.data
}

/**
 * @description: 获取用户信息
 * @return {Promise<DataResponse<UserInfo>>}
 */
export const updateAgreeState = async (): Promise<DataResponse<any>> => {
  const res = await request(
    '/storybrooke-manifest-assistor/client/user-about-Info/auth',
  )
  return res.data
}

/**
 * @description: 获取用户企业VIP信息
 * @return {Promise<DataResponse<boolean>>}
 */
export const fetchEnterpriseVipState = async (): Promise<
  DataResponse<boolean>
> => {
  const res = await request(
    '/storybrooke-manifest-assistor/client/user-about-Info/enterpriseVipState',
  )
  return res.data
}

interface SystemAuditStatus {
  /** 协议图片url */
  protocolUrl: string
  /** 0:审核中 1:驳回 2:审核通过, -1 没申请 */
  state: 0 | 1 | 2 | -1
  /** 审核摘要 */
  remark: string
}

/**
 * 获取开通系统审核状态信息
 */
export const getOpenSystemStatus = async () => {
  const res = await request<SystemAuditStatus>('/enterprises/audit-abstract', {
    baseURL: BASE_API,
  })
  return res.data
}

/**
 * 申请开通系统
 * @param file
 */
export const insOpenSystem = async (file: string) => {
  const res = await request('/user/apply-open', {
    method: 'post',
    data: { attachmentUrl: file },
    baseURL: COMMON_API,
  })
  return res.data
}

/**
 * 获取委托协议模版
 */
export const getAgreementTemplateFile = async (params: any) => {
  const res = await request('/enterprise/apply-contract', {
    method: 'post',
    baseURL: OVERSEAS_API,
    data: { businessType: 'agreement', ...params },
  })
  return res.data
}
